export default __webpack_public_path__ + "static/hero-9667bc5f8ab93ba9aa1ca52770b6bb97.jpg";